import React, {useMemo} from 'react';
import styles from './Film.module.scss';

const Film = ({ images, direction, Duration }) => {
    const animationClass = direction === 'rtl' ? styles.rtl : styles.ltr;

    const content = useMemo(() => {
        return images.map((item, index) => <img key={index} src={item.src} alt={item.alt} />);
    }, [images]);
    
    return (
        <div className={`${styles.wrap_block} ${animationClass}`}>
            <div className={styles.block_img} style={{animationDuration: `${Duration}s`}}>
                {content}
                {content}
            </div>
        </div>
    );
};

export default Film;
